import { Checkbox, Stack } from 'component-library';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormField } from '@/components';

export type IndicatorProductSubscriptionFormValues = {
  indicator_product_subscription: {
    calculation_enabled: boolean;
    use_geomodel_service_for_facts: boolean;
    sync_plots_with_geomodel_service: boolean;
    sync_data_for_plots: boolean;
  };
};

export const IndicatorProductSubscriptionFormFields = ({
  form,
  countOfPlotsSynced,
}: {
  form: UseFormReturn<IndicatorProductSubscriptionFormValues>;
  countOfPlotsSynced: number;
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={4}>
      <FormField
        control={form.control}
        name='indicator_product_subscription.calculation_enabled'
        render={({ field }) => (
          <Stack direction='row' spacing={2} className='items-center'>
            <Checkbox checked={!!field.value} onCheckedChange={field.onChange} />
            <span className='typography-body1'>
              {t('shared.ndiOrganizationSubscriptions.editPage.fields.calculationEnabled')}
            </span>
          </Stack>
        )}
      />
      <FormField
        control={form.control}
        name='indicator_product_subscription.use_geomodel_service_for_facts'
        render={({ field }) => (
          <Stack direction='row' spacing={2} className='items-center'>
            <Checkbox checked={!!field.value} onCheckedChange={field.onChange} />
            <span className='typography-body1'>
              {t('shared.ndiOrganizationSubscriptions.editPage.fields.useGeomodelServiceForFacts')}
            </span>
          </Stack>
        )}
      />
      <FormField
        control={form.control}
        name='indicator_product_subscription.sync_plots_with_geomodel_service'
        render={({ field }) => (
          <Stack direction='row' spacing={2} className='items-center'>
            <Checkbox checked={!!field.value} onCheckedChange={field.onChange} />
            <span className='typography-body1'>
              {t('shared.ndiOrganizationSubscriptions.editPage.fields.syncPlotsWithGeomodelService')}
            </span>
          </Stack>
        )}
      />
      <FormField
        control={form.control}
        name='indicator_product_subscription.sync_data_for_plots'
        render={({ field }) => (
          <Stack direction='row' spacing={2} className='items-center'>
            <Checkbox checked={!!field.value} onCheckedChange={field.onChange} />
            <span className='typography-body1'>
              {t('shared.ndiOrganizationSubscriptions.editPage.fields.syncDataForPlots')}
            </span>
          </Stack>
        )}
      />
      <span className='typography-body2 text-text-secondary'>
        {t('shared.ndiOrganizationSubscriptions.editPage.fields.countOfPlotsSynced', { count: countOfPlotsSynced })}
      </span>
    </Stack>
  );
};
